export default [
  { label: 'Pathway', value: 'core' },
  { label: 'Oracle', value: 'pro' },
  { label: 'Unity', value: 'group' },
  { label: 'Solo', value: 'solo' },
  { label: 'Cohort', value: 'cohort' },
];